import { render, staticRenderFns } from "./UnvanComboSelect.vue?vue&type=template&id=2aec1c5f"
import script from "./UnvanComboSelect.vue?vue&type=script&lang=js"
export * from "./UnvanComboSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports